import { Component } from '@angular/core';
import { BaseSectionComponent } from '../base-section.component';
import { AssetPipe } from '../../../../../../../../pipes/asset.pipe';

@Component({
    selector: 'app-section-external-tools',
    templateUrl: './section-external-tools.component.html',
    styleUrls: ['./section-external-tools.component.scss'],
    imports: [
        AssetPipe
    ],
    standalone: true
})
export class SectionExternalToolsComponent extends BaseSectionComponent {

}